import '@/utils/login';
import Vue from 'vue';
import Router from 'vue-router';
import routerInfo from './router';
import App from './App.vue';
import { install as I18nVuePlugin } from '@/i18n';
import { rem, initReport } from '@tencent/ppd-base-libs';
import { aegis } from '@tencent/wphk-base-report';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { handleBigFont } from '@tencent/wphk-base-utils';
import { setServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { plugin } from '@tencent/wphk-bi';
import mtaGlobalConfig from '@/mta-config-global';
import { language } from '@tencent/wphk-utils';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Hong_Kong');

// 设置系统时间
const serverTimeMills = (window as unknown as { __$$_serverTimeMills?: number }).__$$_serverTimeMills;
const serverTime = serverTimeMills ? new Date(serverTimeMills) : new Date();
setServerTime(serverTime.getTime());

// 处理大字体闪动
handleBigFont();

// 设置默认语言（用于 url 中设置了 lang 但是 lang 不在允许的语言列表中时生效）
language.setLanguage('', undefined, {
  key: 'lang',
  defaultLang: 'zh-hk',
  keyMap: {
    'zh-tw': () => 'zh-hk',
  },
});

// pinia初始化
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

aegis.init({ id: process.env.VUE_APP_PKGNAME });

// 添加全局i18n函数
Vue.use(I18nVuePlugin);

// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);

Vue.use(plugin, {
  ...mtaGlobalConfig,
  route: router,
  isUseBeacon: true,
  mtaUrl: 'https://hq-tracking-pay.qq.com/report/minipro/v2',
});

// 初始化上报
initReport({
  router,
  appEnv: process.env.VUE_APP_ENV,
  business: process.env.VUE_APP_PKGNAME,
  isReportPageStayedTime: true, // 是否上报页面停留时间
  bi: {
    reportNeedLogin: true,
  },
  appVersion: process.env.VUE_APP_SENTRY_VERSION,
}, Vue);

// 开启rem布局
rem();

Vue.config.productionTip = false;

// 忽略微信的自定义元素
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
];

new Vue({
  router,
  render: h => h(App),
  pinia,
}).$mount('#app');

aegis.reportTime('main_ready');
